import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import React from 'react';
import { docketColumnData } from '../Data/ColumnData';
import SyncfusionDataTable from './syncfusionDataTable';
import { TextField } from '@mui/material';
const widthArr = {
  journeyDetails: '1800px',
  transfers: 'auto',
  weighbridge: '1600px',
};

const NotesSection = ({ value, disabled, onEdit }) => {
  return (
    <Box>
      <Typography variant="h6" style={{ marginBottom: 6 }}>
        Internal WH Notes
      </Typography>

      <TextField
        fullWidth
        multiline
        minRows={3}
        variant="outlined"
        value={value || ''}
        placeholder="No internal notes added"
        InputProps={{
          readOnly: true,
        }}
        disabled={disabled}
        onClick={onEdit}
      />
    </Box>
  );
};

const DocketInfoDialog = ({
  open,
  docketInfoData,
  handleCloseDocketInfoModal,
  docketMainData,
  handleDocketInfoEdit,
  handleDocketDocs,
}) => {
  console.log(docketMainData, 'ddata');
  const headerUIArray = {
    weighbridge:
      docketMainData?.isDocketOpen === 'OPEN' ? (
        <Button size="small" variant="contained" color="primary" onClick={() => handleDocketInfoEdit('weighbridge', null)}>
          Add
        </Button>
      ) : null,
  };

  return (
    <Dialog maxWidth="xl" open={open} onClose={handleCloseDocketInfoModal} disableAutoFocus disableEnforceFocus>
      <DialogTitle>
        <Typography style={{ fontSize: '1.5rem' }} component="div">
          Docket Data - ID : {docketMainData.docketNumber ?? ''}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box
          noValidate
          component="div"
          className="DocketInfoDialog"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            m: 'auto',
            width: '100%',
            height: '70vh',
            gap: '1rem',
            borderRadius: '0.5rem',
          }}>
          {Object.keys(docketColumnData)
            .filter(section => {
              if (section === 'loadingDetails' || section === 'weighbridge') return true;
              const sectionData = docketInfoData?.[section];
              return Array.isArray(sectionData) && sectionData.length > 0;
            })
            .map((section, index) => {
              const loadingRow = docketInfoData?.loadingDetails?.[0];
              return (
                <React.Fragment>
                  <SyncfusionDataTable
                    key={index}
                    sectionName={section}
                    columns={docketColumnData[section]}
                    data={docketInfoData[section]}
                    handleDocketInfoEdit={handleDocketInfoEdit}
                    minWidth={widthArr[section]}
                    handleDocketDocs={handleDocketDocs}
                    headerUI={headerUIArray[section]}
                    docketMainData={docketMainData}
                  />
                  {section === 'loadingDetails' && (
                    <NotesSection
                      value={docketMainData?.internalNoteforWH}
                      onEdit={() => handleDocketInfoEdit('loadingDetails', loadingRow)}
                    />
                  )}
                </React.Fragment>
              );
            })}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleCloseDocketInfoModal}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DocketInfoDialog;
